import React, { PureComponent } from 'react';
import { Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class SidebarCategory extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    route: PropTypes.string.isRequired,
    icon: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);

    this.state = {
      collapse: window.location.pathname.includes(props.route)
    };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  render() {
    const { collapse } = this.state;
    const { icon, title, children, route, className } = this.props;
    const isActive = window.location.pathname.includes(route);
    return (
      <div
        className={classnames('sidebar__category-wrap', {
          'sidebar__category-wrap--open': collapse
        })}
      >
        <div
          className={classnames('sidebar__category', 'sidebar__link', {
            'active-menu-item': isActive
          })}
          onClick={this.toggle}
        >
          {icon ? <span className={`sidebar__link-icon ${icon}-icon`} /> : ''}
          <span className="sidebar__link-title">{title}</span>
          <span className="sidebar__category-icon lnr lnr-chevron-right" />
        </div>
        <Collapse isOpen={collapse} className="sidebar__submenu-wrap">
          <ul className={classnames('sidebar__submenu', className)}>
            <div>{children}</div>
          </ul>
        </Collapse>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/sidebar/SidebarCategory.js